function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "local_library_24px"
}, React.createElement("path", {
  id: "icon/maps/local_library_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 4.8927C15 6.55267 13.66 7.8927 12 7.8927C10.34 7.8927 9 6.55267 9 4.8927C9 3.23273 10.34 1.8927 12 1.8927C13.66 1.8927 15 3.23273 15 4.8927ZM5.32001 8.09265C7.88 8.55267 10.18 9.74268 12 11.4427C13.82 9.74268 16.12 8.55267 18.68 8.09265C19.89 7.88269 21 8.84265 21 10.0727V16.9927C21 17.9527 20.23 18.8827 19.29 19.0127C16.77 19.3327 14.48 20.3827 12.61 21.9127C12.26 22.1927 11.69 22.1627 11.34 21.8727C9.47998 20.3527 7.21002 19.3227 4.71002 19.0027C3.71997 18.8727 3 17.9927 3 16.3127V10.0727C3 8.84265 4.10999 7.88269 5.32001 8.09265Z",
  fill: "black",
  fillOpacity: 0.54
}));

var SvgDemplot = function SvgDemplot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDemplot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/demplot.6b618f9a.svg";
export { ForwardRef as ReactComponent };